module.exports = __webpack_public_path__ + "img/q3.4632d7d2.png";